import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { property as r } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as o } from "../../core/accessorSupport/decorators/subclass.js";
import { read as t, write as s } from "../effects/jsonUtils.js";

var i = function i(_i2) {
  var n = /*#__PURE__*/function (_i) {
    _inherits(n, _i);

    var _super = _createSuper(n);

    function n() {
      var _this;

      _classCallCheck(this, n);

      _this = _super.apply(this, arguments), _this.blendMode = "normal", _this.effect = null;
      return _this;
    }

    return n;
  }(_i2);

  return e([r({
    type: ["average", "color-burn", "color-dodge", "color", "darken", "destination-atop", "destination-in", "destination-out", "destination-over", "difference", "exclusion", "hard-light", "hue", "invert", "lighten", "lighter", "luminosity", "minus", "multiply", "normal", "overlay", "plus", "reflect", "saturation", "screen", "soft-light", "source-atop", "source-in", "source-out", "vivid-light", "xor"],
    nonNullable: !0,
    json: {
      read: !1,
      write: !1,
      origins: {
        "web-map": {
          read: !0,
          write: !0
        }
      }
    }
  })], n.prototype, "blendMode", void 0), e([r({
    json: {
      read: !1,
      write: !1,
      origins: {
        "web-map": {
          read: {
            reader: t
          },
          write: {
            allowNull: !0,
            writer: s
          }
        }
      }
    }
  })], n.prototype, "effect", void 0), n = e([o("esri.layers.mixins.BlendLayer")], n), n;
};

export { i as BlendLayer };